// extracted by mini-css-extract-plugin
export default {"container":"CommoditiesEditChooseOrganism_container__Ksy09"};